import pxToRem from "theme/base/pxToRem";
import colors from "theme/theme-light/colors";

const dateCalendar = {
  styleOverrides: {
    root: {
      gap: pxToRem(16),
      height: "unset",
      paddingBottom: pxToRem(20),
      ".MuiDateCalendar-viewTransitionContainer": {
        border: `1px solid ${colors.stroke.strokeDefault}`,
        borderRadius: pxToRem(8),
      },
      ".MuiPickersCalendarHeader-label": {
        textTransform: "capitalize",
      },
    },
  },
};

export default dateCalendar;
